import * as $ from 'jquery';
import 'MagnificPopup';
import 'bootstrap';
import 'selectize';
import * as moment from 'moment';

export class travelSubsidy {
    loadIBEPopUp(): void {
        let gtsContinue = $('.gts-ibe');
        gtsContinue.off('click', '.gts-form-ibe').on('click', '.gts-form-ibe', (evt: any) => {
            evt.preventDefault();
            $.magnificPopup.open({
                items: {
                    src: '#ibe-standalone'
                },
                type: 'inline',
                midClick: true,
                enableEscapeKey: false,
                showCloseBtn: false,
                closeOnBgClick: false,
                callbacks: {
                    open: function () {
                        let instance = this;
                        let $el: any = instance.content;
                        $el.css('border-bottom', 'none');
                        let $closeIbe: any = $el.find('.close-booking');
                        $closeIbe.on('click', (e: any) => {
                            $.magnificPopup.close();
                        });
                        var options1 = $el.find('.payment-method-options li label');
                        var values1 = $.map(options1, function (option: any) {
                            if (option.innerText.trim() != 'Card / Cash') {
                                option.classList.add('hide');
                            }
                        });
                        $el.find('.trip-type--container .multiCityTrip').addClass('hide');
                        $el.find('.trip-type--container .roundTheWorldTrip').removeClass('visible-lg');
                        $el.find('.trip-type--container .roundTheWorldTrip').addClass('hide');
                        $el.find('.trip-type--container .sideTrip').addClass('hide');
                        $el.find('.couponCode').addClass('hide');
                        $el.find('#isSideTripEnable').val('No');
                        let ibeNowDate:any      = new Date();	
                        let gtsMaxdays: any = new Date($('[data-gts-maxdays]').attr('data-gts-maxdays'));				
                        let maxLimitDate: any = new Date(gtsMaxdays.getFullYear(), gtsMaxdays.getMonth(), gtsMaxdays.getDate(), 0, 0, 0, 0);
                        $el.find('.departureDate.oneWay-trip').datepicker('option', 'maxDate', maxLimitDate);
                        $el.find('.departureDate').datepicker('option', 'maxDate', maxLimitDate);
                        $el.find('.returnDate').datepicker('option', 'maxDate', maxLimitDate);
                        $el.find('.departureDateMobile.oneWay-trip').datepicker('option', 'maxDate', maxLimitDate);
                        $el.find('.departureDateMobile').datepicker('option', 'maxDate', maxLimitDate);
                        $el.find('.returnDateMobile').datepicker('option', 'maxDate', maxLimitDate);

                        $el.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
                        $el.find('.child-nos .input-group--btn .plus').attr('disabled', true);
                        $el.find('.teenager-nos .input-group--btn .plus').attr('disabled', true);
                        // $el.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
                        $el.find('.adult-nos .input-group--btn .minus').attr('disabled', true);
                        $el.find('.child-nos .input-group--btn .minus').attr('disabled', true);
                        $el.find('.teenager-nos .input-group--btn .minus').attr('disabled', true);
                        // $el.find('.infant-nos .input-group--btn .minus').attr('disabled', true);
                        // $el.find('.booking-person.infant-cat').addClass('hide');
                        $el.find('.booking-person.group-booking').addClass('hide');
                        $el.find('.passenger-details-selected .ticket-infant--input').val(0);
                        $el.find('.passenger-details-selected .infant-booking--error').hide();
                       // if($("#traveller-type_"+i) == 'Adult')
                       let adultCnt:any =0;
                       let childCnt:any =0;
                       for (var i = 0; i < 9; i++) {
                         if ($('#firsttraveller_'+i+'--select'). is(":checked") == true){
                             let dob:any = $("#traveller-dob_"+i).text();
                             let age:any = moment().diff(dob, 'years');
                             if(age>=12){
                                adultCnt++;
                            }		
                            else
                            {
                                childCnt++;
                            }
                         }
                       }
                       let $totalTickets = parseInt(adultCnt) + parseInt(childCnt);
                       $el.find('input[name="passengersAdult"]').val(adultCnt);
                       $el.find('input[name="passengersChildren"]').val(childCnt);
                       $el.find('.total-nos').html($totalTickets);
                        if (window.innerWidth < 768) {
                            $el.css({ 'padding': '0', 'height': '100%' });
                            $el.parent().css({ 'height': '100%' });
                            $el.parent().parent().css({ 'padding': '0' });
                            $el.find('.mobile-ibe').css({ 'height': '100%', 'padding': '0' });
                            $el.find('#mobile-bookflight--container').css({ 'height': '100%' });
                            $('body').css('height', $(window).height());
                            $('body').css('overflow', 'hidden');
                            $el.find('.passenger-details-selected .ticket-mob-infant--input').val(0);
                            $el.find('.passenger-details-selected .infant-booking--error---mobile').hide();
                        }
                       
                    },
                    close: function () {
                        $('body').css('overflow', '');
                        $('body').css('height', '');
                    }
                }
            }, 0);
        });
    }
}

let scope: Element = document.querySelector('.gts-container');
if (scope) {
    try {
        let travelsubsidy = new travelSubsidy();
        travelsubsidy.loadIBEPopUp();
    } catch (e) { console.error(e); }
}